import { render, staticRenderFns } from "./AdminBusinessSettingsLabels.vue?vue&type=template&id=7e3c5814&"
import script from "./AdminBusinessSettingsLabels.vue?vue&type=script&lang=js&"
export * from "./AdminBusinessSettingsLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports